import { render } from "./TimesheetPeriod.vue?vue&type=template&id=e0a5176c&scoped=true"
import script from "./TimesheetPeriod.vue?vue&type=script&lang=js"
export * from "./TimesheetPeriod.vue?vue&type=script&lang=js"

import "./timesheet-period.scss?vue&type=style&index=0&id=e0a5176c&lang=scss&scoped=true"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0a5176c"]])

export default __exports__